import { useState } from "react";

export interface IconButtonProps {
  className?: string;
  style?: React.CSSProperties;
  backgroundColor?: string;
  icon: string;
  alt: string;
  iconClassName?: string;
  text: React.ReactNode;
  textClassName?: string;
  textColor?: string;
  iconLocate: "left" | "right";
  gradient?: string;
  disabled?: boolean;
  hoverBackgroundColor?: string;
  onClick: () => void;
}

export default function IconButton(props: IconButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (!props.disabled) {
      props.onClick();
    }
  };

  const handleMouseEnter = () => {
    if (!props.disabled) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <button
      type="button"
      className={`${props.className ?? ""} ${props.gradient ?? ""} ${
        props.disabled ? "disabled" : ""
      }`}
      style={{
        backgroundColor:
          isHovered && props.hoverBackgroundColor && !props.disabled
            ? props.hoverBackgroundColor
            : props.backgroundColor ?? "transparent",
        transition: "background-color 0.2s ease-in-out",
        ...props.style,
        ...(props.disabled && {
          color: "rgba(0, 0, 0, 0.2)",
          background: "rgba(0, 0, 0, 0.08)",
          cursor: "not-allowed",
        }),
      }}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={props.disabled}
    >
      {props.iconLocate === "left" && (
        <img
          className={`${props.iconClassName ?? ""} ${props.disabled ? "opacity-20" : ""}`}
          src={props.icon}
          alt={props.alt}
          width={24}
          height={24}
        />
      )}
      <span
        className={`${props.textClassName ?? ""} ${props.disabled ? "opacity-20" : ""}`}
        style={{
          color: props.disabled ? "rgba(0, 0, 0, 0.2)" : props.textColor,
        }}
      >
        {props.text}
      </span>
      {props.iconLocate === "right" && (
        <img
          className={`${props.iconClassName ?? ""} ${props.disabled ? "opacity-20" : ""}`}
          src={props.icon}
          alt={props.alt}
          width={24}
          height={24}
        />
      )}
    </button>
  );
}
